import { useState } from "react";
import { useTranslate } from "@refinedev/core";
import { FormCard, Field, PasswordField, CheckboxField, Button, UserIcon, LockIcon } from "@fawkes/ui";

import { loginAdmin } from "../../authProvider";

// jmix-exit E3b.1: admin username/password login — re-invents the discarded Vaadin LoginView against
// POST /api/auth/login. Composes @fawkes/ui primitives only (Golden Rule: no shared-component edits).
// On success it calls onAuthenticated so the shell re-evaluates the in-memory token → renders authed.
export function AdminLogin({ onAuthenticated }: { onAuthenticated: () => void }) {
  const t = useTranslate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(undefined);
    setBusy(true);
    const result = await loginAdmin(username, password, remember);
    setBusy(false);
    if (result.ok) {
      onAuthenticated();
    } else {
      // Uniform message — never reveals whether the username or the password was wrong.
      setError(t(`auth.error.${result.message}`));
    }
  }

  return (
    <form className="fawkes-auth__form" onSubmit={submit} noValidate>
      <FormCard>
        <h1 className="fawkes-auth__heading">{t("auth.admin.title")}</h1>
        <p className="fawkes-auth__lede">{t("auth.admin.lede")}</p>
        <Field
          label={t("auth.field.username")}
          icon={<UserIcon width={16} height={16} />}
          value={username}
          autoComplete="username"
          autoFocus
          onChange={(e) => setUsername(e.target.value)}
        />
        <PasswordField
          label={t("auth.field.password")}
          icon={<LockIcon width={16} height={16} />}
          value={password}
          autoComplete="current-password"
          revealLabel={t("auth.field.revealPassword")}
          hideLabel={t("auth.field.hidePassword")}
          onChange={(e) => setPassword(e.target.value)}
        />
        <CheckboxField
          label={t("auth.admin.rememberMe")}
          checked={remember}
          onChange={(e) => setRemember(e.target.checked)}
        />
        {error ? (
          <p className="fawkes-auth__error" role="alert">
            {error}
          </p>
        ) : null}
        <Button type="submit" disabled={busy}>
          {busy ? t("auth.admin.submitting") : t("auth.admin.submit")}
        </Button>
      </FormCard>
    </form>
  );
}
